import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

import useWindowSize from "../../hooks/useWindowSize";
import useWindowPosition from "../../hooks/useWindowPosition";

const PageProgressBar = ({ articleHeight }) => {
  const size = useWindowSize();
  const scrollPosition = useWindowPosition();
  const height = articleHeight;

  const progressBarProgressStyle = {
    width: "0px",
  };

  let calcWidth = (scrollPosition / height) * size.width;

  progressBarProgressStyle.width = `${Math.min(calcWidth, size.width)}px`;

  return (
    <div className="page-progress-bar__container">
      <div className="page-progress-bar"></div>
      <div
        style={progressBarProgressStyle}
        className="page-progress-bar--progress"
      ></div>
    </div>
  );
};

PageProgressBar.propTypes = {
  articleHeight: PropTypes.number,
};

PageProgressBar.defaultProps = {
  articleHeight: 0,
};

export default PageProgressBar;
